/**
 * Vídeos da playlist "📚 TUTORIAIS NÚCLEO" do canal @UseNucleo no YouTube.
 *
 * Cada tópico da Ajuda aponta para estes vídeos pelo `id` do YouTube
 * (campo `videos` do tópico). Dado puro, como o resto do conteúdo.
 *
 * Quase todos são Shorts (vídeo em pé, 9:16). O único horizontal é a
 * Introdução, marcado com `horizontal: true`.
 *
 * A playlist tem versões repetidas de alguns temas (Mesas, QR Code das mesas,
 * Ficha técnica, Compras, Estoque — mesma duração, título antigo). Ficou só a
 * versão de título novo; as antigas estão listadas em REPETIDOS para não
 * voltarem por engano.
 */
export const PLAYLIST_URL = "https://www.youtube.com/playlist?list=PLZdigyFxwj8A";

export const VIDEOS = {
  "WXDvR6pvCPM": { titulo: "Introdução: como usar o Núcleo", duracao: "5:22", horizontal: true },
  "A4OClLoSHSg": { titulo: "Entrar no sistema", duracao: "2:36" },
  "-T3587U38EA": { titulo: "Como funciona a Visão Geral", duracao: "2:23" },
  "yiDx_AtEMOk": { titulo: "Mudar a aparência do sistema", duracao: "1:30" },
  "Ew3E3kD7xic": { titulo: "Cadastrar os dados da sua empresa", duracao: "1:52" },
  "b9iie0gSTMo": { titulo: "Ajustar as preferências", duracao: "2:04" },
  "s07XAMxZI8Y": { titulo: "Configurar a aba Controle", duracao: "2:24" },
  "BzLx77utLoc": { titulo: "Definir os horários de funcionamento", duracao: "1:55" },
  "pYM40n-hctA": { titulo: "Criar e organizar categorias", duracao: "2:01" },
  "GWR7awqNj9g": { titulo: "Cadastrar produtos", duracao: "1:43" },
  "MXkCAW6_UN4": { titulo: "Cadastrar etapas no cardápio", duracao: "2:18" },
  "H8L5j1NsEuM": { titulo: "Esgotar ou esconder produtos", duracao: "1:35" },
  "qHaRs-ihD5Q": { titulo: "Configurar a ficha técnica", duracao: "2:59" },
  "0Eb2VCgJDbY": { titulo: "Adicionar banners no cardápio", duracao: "2:11" },
  "UcNmbJ716qk": { titulo: "Acompanhar as entregas", duracao: "1:34" },
  "lll1RjRmzLE": { titulo: "Cadastrar os bairros de entrega", duracao: "1:38" },
  "Qzklb_zt4FE": { titulo: "Usar o módulo Mesas", duracao: "2:45" },
  "-E0nSLbzjPI": { titulo: "Gerar o QR Code das mesas", duracao: "2:43" },
  "YlKw7M0VpDY": { titulo: "Configurar a impressão dos cupons", duracao: "2:42" },
  "d6EDroQvKzc": { titulo: "Destacar uma categoria no cupom de entrega", duracao: "1:25" },
  "KZKqmUp9OZE": { titulo: "Usar o caixa", duracao: "2:28" },
  "UMu-14uVjDc": { titulo: "Cadastrar formas de pagamento", duracao: "2:23" },
  "KCJ0b6OnBY0": { titulo: "Cadastrar despesas", duracao: "2:37" },
  "cK-J0aWQGPY": { titulo: "Analisar o fluxo de caixa", duracao: "2:12" },
  "kV2nkuBz2FI": { titulo: "Entender o DRE", duracao: "2:24" },
  "sVcHNjOTKGg": { titulo: "Controlar o estoque", duracao: "2:32" },
  "g4fxXZZCsV0": { titulo: "Lançar as compras", duracao: "2:10" },
  "a5l6SbsaHVg": { titulo: "Ler o relatório de vendas", duracao: "2:02" },
  "4h-mVDDE5qU": { titulo: "Ler o relatório de produtos", duracao: "1:39" },
  "G9BQtlOWd4M": { titulo: "Entender o relatório do cardápio", duracao: "1:43" },
  "az0aE_WpYmw": { titulo: "Entender o relatório de pagamentos", duracao: "2:13" },
  "5-CJOpMxnv0": { titulo: "Entender o relatório de módulos", duracao: "2:56" },
  "CT4ChZ7Rvkg": { titulo: "Analisar o relatório de categorias", duracao: "1:47" },
  "C4YX4dvGiK4": { titulo: "Analisar o relatório de estoque", duracao: "2:05" },
  "2XU_eKdhsZM": { titulo: "Organizar os seus clientes", duracao: "2:36" },
  "rXusPO75dCc": { titulo: "Cadastrar funcionários", duracao: "2:50" },
  "Ewi3IFYXtVs": { titulo: "Organizar os seus fornecedores", duracao: "2:27" },
  "ibJuqKi9Sxk": { titulo: "Configurar as avaliações", duracao: "2:23" },
  "syuIlQWTDak": { titulo: "Como funcionam as Sugestões Inteligentes", duracao: "1:58" },
  "IJTL5dE8NEY": { titulo: "Impulsionar as vendas com cashback", duracao: "2:04" },
};

/** Versões antigas que estão na playlist mas ficaram de fora (ver topo). */
export const REPETIDOS = {
  "fGT7qEIg3NI": "Qzklb_zt4FE", // Mesas
  "nOn76QezvT8": "-E0nSLbzjPI", // QR Code das mesas
  "jbZXh9Z7L8g": "qHaRs-ihD5Q", // Ficha técnica
  "wzVE4vCHXQo": "g4fxXZZCsV0", // Compras
  "y7hQIB0xBf4": "sVcHNjOTKGg", // Estoque
};

/** Shorts abrem na tela de Shorts do YouTube; o horizontal, na de vídeo comum. */
export const linkDoVideo = (id) =>
  VIDEOS[id]?.horizontal ? `https://www.youtube.com/watch?v=${id}` : `https://www.youtube.com/shorts/${id}`;
